import { initializeApplication, INITIALIZE_APPLICATION, INITIALIZE_APPLICATION_SUCCESS, INITIALIZE_APPLICATION_ERROR } from '../actions/initialize-application-actions';
import { SAVE_SETTINGS, SAVE_SETTINGS_ERROR, SAVE_SETTINGS_SUCCESS } from '../actions/save-settings-actions';
import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR } from './../actions/login-actions';
import { LOGOUT, LOGOUT_SUCCESS, LOGOUT_ERROR } from './../actions/logout-actions';
import { RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR } from '../actions/reset-password-actions';
import { REQUEST_RESET_PASSWORD, REQUEST_RESET_PASSWORD_SUCCESS, REQUEST_RESET_PASSWORD_ERROR } from '../actions/request-reset-password-actions';
import { SIGNUP, SIGNUP_SUCCESS, SIGNUP_ERROR } from '../actions/sign-up-actions';
import { CONFIRM_SIGNUP, CONFIRM_SIGNUP_SUCCESS, CONFIRM_SIGNUP_ERROR } from '../actions/confirm-sign-up-actions';
import { RESEND_CONFIRMATION_CODE, RESEND_CONFIRMATION_CODE_SUCCESS, RESEND_CONFIRMATION_CODE_ERROR } from '../actions/resend-confirmation-code-actions';

/**
 * 
 */
const initialState = {
	appReady: false,
	user: {
		isAuthenticated: false,
		userData: null
	},
	settings: {
		username: '',
		email: ''
	},
	logout: {
		isLoggedOut: false
	},
	login: {
		isLoading: false,
		isLoggedIn: false,
		messages: [],
		errors: []
	},
	requestResetPassword: {
		isLoading: false,
		messages: [],
		errors: []
	},
	resetPassword: {
		isLoading: false,
		messages: [],
		errors: []
	},
	signup: {
		signupSuccessful: false,
		isLoading: false,
		messages: [],
		errors: []
	},
	confirmSignup: {
		confirmSignupSuccessful: false,
		isLoading: false,
		messages: [],
		errors: []
	},
	resendConfirmationCode: {
		resendConfirmationCodeSuccessful: false,
		isLoading: false,
		messages: [],
		errors: []
	}
};

/**
 * 
 * @param {*} state 
 * @param {*} action 
 */
const reduxApp = (state = initialState, action) => {
	//
	console.log(action);
	//
	switch (action.type) {
		// - - Initialize app
		case INITIALIZE_APPLICATION:
			return Object.assign({}, state, {});

		case INITIALIZE_APPLICATION_SUCCESS:
			console.log('User is authenticted', action.user);
			return Object.assign({}, state, {
				appReady: true,
				user: {
					isAuthenticated: true,
					userData: action.user
				}
			});

		case INITIALIZE_APPLICATION_ERROR:
			console.log('User is NOT authenticted', action.errors);
			return Object.assign({}, state, {
				appReady: true,
				user: {
					isAuthenticated: false
				}
			});

		// - - Logout
		case LOGOUT:
			return Object.assign({}, state, {});

		case LOGOUT_SUCCESS:
			return Object.assign({}, state, {
				user: {
					isAuthenticated: false,
					userData: null
				}
			});

		case LOGOUT_ERROR:
			return Object.assign({}, state, {
				signup: {
					isLoading: true
				}
			});

		// - - Signup
		case SIGNUP:
			return Object.assign({}, state, {
				signup: {
					isLoading: true,
					errors: [],
					messages: [{ message: 'Loading...' }]
				}
			});

		case SIGNUP_SUCCESS:
			return Object.assign({}, state, {
				signup: {
					isLoading: false,
					signupSuccessful: true,
					messages: [{ message: 'Signup successful.' }]
				}
			});

		case SIGNUP_ERROR:
			return Object.assign({}, state, {
				signup: {
					isLoading: false,
					errors: [{ message: action.errors.message }]
				}
			});

		// - - Confirm signup
		case CONFIRM_SIGNUP:
			return Object.assign({}, state, {
				confirmSignup: {
					isLoading: true,
					errors: [],
					messages: [{ message: 'Loading...' }]
				}
			});

		case CONFIRM_SIGNUP_SUCCESS:
			return Object.assign({}, state, {
				confirmSignup: {
					isLoading: false,
					confirmSignupSuccessful: true,
					messages: [{ message: 'Confirm signup successful.' }]
				}
			});

		case CONFIRM_SIGNUP_ERROR:
			return Object.assign({}, state, {
				confirmSignup: {
					isLoading: false,
					errors: [{ message: action.errors.message }]
				}
			});

		// - - Resend confirmation code
		case RESEND_CONFIRMATION_CODE:
			return Object.assign({}, state, {});

		case RESEND_CONFIRMATION_CODE_SUCCESS:
			return Object.assign({}, state, {
				resendConfirmationCode: {
					resendConfirmationCodeSuccessful: true
				}
			});

		case RESEND_CONFIRMATION_CODE_ERROR:
			return Object.assign({}, state, {
				// ! Using the error box of the form on the page here
				confirmSignup: {
					errors: [{ message: action.errors.message }]
				}
			});

		// - - Login

		case LOGIN:
			return Object.assign({}, state, {
				login: {
					isLoading: true,
					errors: [],
					messages: [{ message: 'Loading...' }]
				}
			});

		case LOGIN_SUCCESS:
			return Object.assign({}, state, {
				user: {
					isAuthenticated: true,
					userData: action.user
				},

				login: {
					isLoading: false,
					messages: [{ message: 'Login ok!' }]
				}
			});

		case LOGIN_ERROR:
			return Object.assign({}, state, {
				login: {
					isLoading: false,
					errors: [{ message: action.errors.message }]
				}
			});

		// - - Request reset password

		case REQUEST_RESET_PASSWORD:
			return Object.assign({}, state, {
				requestResetPassword: {
					isLoading: true,
					errors: [],
					messages: [{ message: 'Loading...' }]
				}
			});

		case REQUEST_RESET_PASSWORD_SUCCESS:
			return Object.assign({}, state, {
				requestResetPassword: {
					isLoading: false,
					messages: [{ message: 'Code was sent' }]
				}
			});

		case REQUEST_RESET_PASSWORD_ERROR:
			return Object.assign({}, state, {
				requestResetPassword: {
					isLoading: false,
					errors: [{ message: action.error.message }]
				}
			});

		// - - Reset password

		case RESET_PASSWORD:
			return Object.assign({}, state, {
				resetPassword: {
					isLoading: true,
					errors: [],
					messages: [{ message: 'Loading...' }]
				}
			});

		case RESET_PASSWORD_SUCCESS:
			return Object.assign({}, state, {
				resetPassword: {
					isLoading: false,
					messages: [{ message: 'Password reset ok!' }]
				}
			});

		case RESET_PASSWORD_ERROR:
			return Object.assign({}, state, {
				resetPassword: {
					isLoading: false,
					errors: [{ message: action.error.message }]
				}
			});

		// - - Save settings

		case SAVE_SETTINGS:
			return Object.assign({}, state, {
				settings: {
					username: 'loading',
					email: 'loading'
				}
			});

		case SAVE_SETTINGS_SUCCESS:
			return Object.assign({}, state, {
				settings: {
					username: action.username,
					email: action.email
				}
			});

		case SAVE_SETTINGS_ERROR:
			return Object.assign({}, state, {
				settings: {
					username: '(ERROR)',
					email: '(ERROR)'
				}
			});

		// - - Default

		default:
			return state;
	}
};
/**
 * 
 */
export default reduxApp;
